/**
 * AiWand component.
 *
 * @component
 * @returns {JSX.Element} AiWand component.
 */
const AiWand = ({color, size}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? "21"}
      height={size ?? "21"}
      viewBox="0 0 21 21"
      fill="none"
    >
      <path
        d="M12.2518 5.9454L14.8571 3.34007C15.3105 2.88664 16.0457 2.88664 16.4991 3.34007L17.1792 4.02021C17.6327 4.47363 17.6327 5.20878 17.1792 5.66221L14.5739 8.26754M12.2518 5.9454L3.34031 14.8569C2.88689 15.3103 2.88689 16.0454 3.34031 16.4989L4.02045 17.179C4.47388 17.6324 5.20903 17.6324 5.66245 17.179L14.5739 8.26754M12.2518 5.9454L14.5739 8.26754M6.38955 3.29312V5.61526M6.38955 5.61526V7.93739M6.38955 5.61526H4.06741M6.38955 5.61526H8.71169M15.6781 11.0336V13.3557M15.6781 13.3557V15.6779M15.6781 13.3557H13.356M15.6781 13.3557H18.0002M11.0338 14.9038V16.4519M11.0338 16.4519V18M11.0338 16.4519H9.48573M11.0338 16.4519H12.5819"
        stroke={color ?? "#149DFF"}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default AiWand;
